import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { CommissionTransaction } from "@/lib/commission.api";
import type { CommissionViewMode } from "../commission.constants";

export function useCommissionsPageState() {
  const [typeFilter, setTypeFilter] = useState("");
  const [search, setSearch] = useState("");
  const [viewMode, setViewMode] = useState<CommissionViewMode>("table");
  const [selectedCommission, setSelectedCommission] = useState<CommissionTransaction | null>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  return {
    typeFilter,
    setTypeFilter,
    search,
    setSearch,
    viewMode,
    setViewMode,
    selectedCommission,
    setSelectedCommission,
  };
}
